import { useState, useContext } from "react";
import apiFetch from "../../helperFunctions/api";
import useAsyncAction from "../../helperFunctions/useAsyncAction";
import AppContext from "../../contexts/AppContext";
import { Alert, Button, TextField, Stack } from "@mui/material";

export default function StartSession() {
  const [sessionData, setSessionData] = useState("");
  const [instanceName, setInstanceName] = useState("");
  const { API, setSession, setSessionOptions } = useContext(AppContext);
  const { pending, error, run } = useAsyncAction();

  function initializeSession() {
    run(async () => {
      const response = await apiFetch(`${API}/session`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ sessionData, action: "CREATE", sessionName: instanceName }),
      });
      setSessionOptions(await response.json());
      setSession(instanceName);
      setSessionData("");
    });
  }
  return (
    <Stack spacing={0.5}>
      {error && <Alert severity="error">{error}</Alert>}
      <TextField disabled={pending} value={instanceName} onChange={(e) => setInstanceName(e.target.value)} label="Session Name" />
      <TextField disabled={pending} value={sessionData} onChange={(e) => setSessionData(e.target.value)}
        variant="outlined" id="initString" label="Start Init String" />
      <Button disabled={pending || !instanceName.trim() || !sessionData.trim()} onClick={initializeSession} variant="outlined">
        {pending ? "Starting..." : "Start Session"}
      </Button>
    </Stack>
  );
}
